import React from "react";
import { formatToolResultAsMarkdown } from "./formatToolResultAsMarkdown";

export function formatToolResultAsKeyValue(summary: string): React.ReactNode {
	try {
		const parsed = JSON.parse(summary);
		if (parsed && typeof parsed === "object" && !Array.isArray(parsed)) {
			const entries = Object.entries(parsed as Record<string, unknown>).filter(
				([k, v]) =>
					k !== "success" &&
					v !== null &&
					v !== undefined &&
					v !== "" &&
					!(Array.isArray(v) && v.length === 0),
			);
			if (entries.length > 0) {
				return (
					<ul className="trace-step-json-list">
						{entries.map(([k, v]) => (
							<li key={k}>
								<span className="trace-step-json-key">{k}</span>
								<span className="trace-step-json-val">
									{typeof v === "object" ? JSON.stringify(v) : String(v)}
								</span>
							</li>
						))}
					</ul>
				);
			}
		}
	} catch {
		// fall through
	}
	return formatToolResultAsMarkdown(summary);
}
